module.exports = __webpack_public_path__ + "static/media/most_opportunity.23e84989.svg";